var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/react/react?429b": () => (loadSingleton("default", "react", false, () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react-dom/react-dom?49cf": () => (loadSingleton("default", "react-dom", false, () => (Promise.all([__webpack_require__.e(8325), __webpack_require__.e(6828)]).then(() => (() => (__webpack_require__("../node_modules/react-dom/index.js"))))))),
	"webpack/sharing/consume/default/@amzn/austin-core/@amzn/austin-core?d6a7": () => (loadSingletonVersion("default", "@amzn/austin-core", false, [1,2,168,0], () => (Promise.all([__webpack_require__.e(4885), __webpack_require__.e(3529), __webpack_require__.e(4318), __webpack_require__.e(8151), __webpack_require__.e(9802), __webpack_require__.e(8013), __webpack_require__.e(5211), __webpack_require__.e(1735), __webpack_require__.e(5257), __webpack_require__.e(7856), __webpack_require__.e(1966), __webpack_require__.e(2541), __webpack_require__.e(3513), __webpack_require__.e(8221), __webpack_require__.e(6512), __webpack_require__.e(2131), __webpack_require__.e(8282), __webpack_require__.e(5607), __webpack_require__.e(3866), __webpack_require__.e(4711), __webpack_require__.e(6915), __webpack_require__.e(308), __webpack_require__.e(4027), __webpack_require__.e(1907), __webpack_require__.e(8386), __webpack_require__.e(1031), __webpack_require__.e(3704), __webpack_require__.e(6425), __webpack_require__.e(5985)]).then(() => (() => (__webpack_require__("../node_modules/@amzn/austin-core/dist/index.js"))))))),
	"webpack/sharing/consume/default/react/react?3640": () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0],[1,18,0,0],[1,17,0,0],[1,16,8,0],1,1,1], () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react/react?080d": () => (loadSingletonVersion("default", "react", false, [0,18,0,0], () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react-dom/react-dom?0fb8": () => (loadSingletonVersion("default", "react-dom", false, [,[1,18,0,0],[1,17,0,0],1], () => (Promise.all([__webpack_require__.e(8325), __webpack_require__.e(6828)]).then(() => (() => (__webpack_require__("../node_modules/react-dom/index.js"))))))),
	"webpack/sharing/consume/default/react/react?6d67": () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0],[1,18,0,0],[1,17,0,0],[1,16,0,0],[1,15,0,0],1,1,1,1], () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/@tanstack/react-query/@tanstack/react-query": () => (loadSingletonVersion("default", "@tanstack/react-query", false, [1,5,59,0], () => (Promise.all([__webpack_require__.e(7254), __webpack_require__.e(7284)]).then(() => (() => (__webpack_require__("../node_modules/@tanstack/react-query/build/modern/index.js"))))))),
	"webpack/sharing/consume/default/react-dom/react-dom?8f48": () => (loadSingletonVersion("default", "react-dom", false, [,[1,19,0,0],[1,18,0,0],[1,17,0,0],1,1], () => (Promise.all([__webpack_require__.e(8325), __webpack_require__.e(6828)]).then(() => (() => (__webpack_require__("../node_modules/react-dom/index.js"))))))),
	"webpack/sharing/consume/default/react-dom/react-dom?bffe": () => (loadSingletonVersion("default", "react-dom", false, [0,16,6,0], () => (Promise.all([__webpack_require__.e(8325), __webpack_require__.e(6828)]).then(() => (() => (__webpack_require__("../node_modules/react-dom/index.js"))))))),
	"webpack/sharing/consume/default/react/react?167c": () => (loadSingletonVersion("default", "react", false, [0,16,6,0], () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react/react?98f9": () => (loadSingletonVersion("default", "react", false, [,[1,18,0,0],[1,17,0,0],1], () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react/react?c387": () => (loadSingletonVersion("default", "react", false, [0,16,8,0], () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react/react?fb98": () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0],[1,18,0,0],[1,17,0,0],1,1], () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react-router-6/react-router?6324": () => (loadSingleton("default", "react-router-6", false, () => (Promise.all([__webpack_require__.e(744), __webpack_require__.e(7435), __webpack_require__.e(8175)]).then(() => (() => (__webpack_require__("../node_modules/react-router/dist/index.js"))))))),
	"webpack/sharing/consume/default/react-router-dom/react-router-dom?641d": () => (loadStrictVersion("default", "react-router-dom", false, [0,6,29,0], () => (Promise.all([__webpack_require__.e(744), __webpack_require__.e(9348), __webpack_require__.e(8175), __webpack_require__.e(3043)]).then(() => (() => (__webpack_require__("../node_modules/react-router-dom/dist/index.js"))))))),
	"webpack/sharing/consume/default/react/react?a2f5": () => (loadSingletonVersion("default", "react", false, [,[1,18,0,0],[1,17,0,0],[1,16,0,0],[1,15,0,0],[2,0,14],1,1,1,1], () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react/react?62db": () => (loadSingletonVersion("default", "react", false, [,[1,19],[1,18],1], () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react/react?0abc": () => (loadSingletonVersion("default", "react", false, [1,18,3,1], () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react/react?ddd8": () => (loadSingletonVersion("default", "react", false, [0,16,8], () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react-dom/react-dom?aa5d": () => (loadSingletonVersion("default", "react-dom", false, [0,16,8], () => (Promise.all([__webpack_require__.e(8325), __webpack_require__.e(6828)]).then(() => (() => (__webpack_require__("../node_modules/react-dom/index.js"))))))),
	"webpack/sharing/consume/default/react-router-6/react-router?91bc": () => (loadSingletonVersion("default", "react-router-6", false, [4,6,30,0], () => (__webpack_require__.e(7435).then(() => (() => (__webpack_require__("../node_modules/react-router/dist/index.js")))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"1031": [
		"webpack/sharing/consume/default/react/react?6d67"
	],
	"1135": [
		"webpack/sharing/consume/default/react/react?429b"
	],
	"1907": [
		"webpack/sharing/consume/default/react/react?080d"
	],
	"3043": [
		"webpack/sharing/consume/default/react-dom/react-dom?aa5d",
		"webpack/sharing/consume/default/react-router-6/react-router?91bc"
	],
	"3704": [
		"webpack/sharing/consume/default/@tanstack/react-query/@tanstack/react-query",
		"webpack/sharing/consume/default/react-dom/react-dom?8f48",
		"webpack/sharing/consume/default/react-dom/react-dom?bffe",
		"webpack/sharing/consume/default/react/react?167c",
		"webpack/sharing/consume/default/react/react?98f9",
		"webpack/sharing/consume/default/react/react?c387",
		"webpack/sharing/consume/default/react/react?fb98"
	],
	"4027": [
		"webpack/sharing/consume/default/react/react?3640"
	],
	"6425": [
		"webpack/sharing/consume/default/react-router-6/react-router?6324",
		"webpack/sharing/consume/default/react-router-dom/react-router-dom?641d",
		"webpack/sharing/consume/default/react/react?a2f5"
	],
	"6828": [
		"webpack/sharing/consume/default/react/react?0abc"
	],
	"7284": [
		"webpack/sharing/consume/default/react/react?62db"
	],
	"8175": [
		"webpack/sharing/consume/default/react/react?ddd8"
	],
	"8386": [
		"webpack/sharing/consume/default/react-dom/react-dom?0fb8"
	],
	"9157": [
		"webpack/sharing/consume/default/react-dom/react-dom?49cf",
		"webpack/sharing/consume/default/@amzn/austin-core/@amzn/austin-core?d6a7"
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}